import {LocalDateTime} from 'js-joda'
import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface PrismaRequestComment {
    readonly id: number
    readonly prismaRequestId: number
    readonly bpsUserId: number | null
    readonly cis2UserId: number | null
    readonly text: string
    readonly created: LocalDateTime
}

export function prismaRequestCommentDecoder(): Decoder<PrismaRequestComment> {
    return object({
        id: field('id', number()),
        prismaRequestId: field('prismaRequestId', number()),
        bpsUserId: field('bpsUserId', nullable(number())),
        cis2UserId: field('cis2UserId', nullable(number())),
        text: field('text', string()),
        created: field('created', localDateTimeDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestComment.ts